<template>
  <div>
    <breadcrumbs
      :breadcrumb-items="breadcrumbItems"
    />
    <UserToolbar
      v-if="account && Object.keys(account).length !== 0"
      :account="account"
    />

    <LandingForm
      :landing="currentLanding"
      :type="type"
      @switch-to-edit="handleSwitchToEdit"
    />
  </div>
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import Breadcrumbs from '@/views/ui/breadcrumbs/Breadcrumbs.vue'
import UserToolbar from '@/views/dashboard/users/UserToolbar.vue'
import LandingForm from './LandingForm.vue'

export default {
  components: {
    LandingForm,
    Breadcrumbs,
    UserToolbar,
  },
  data() {
    return {
      breadcrumbItems: [],
      account: {},
      type: 'create',
      currentLanding: {
        title: '',
        status: 'active',
        is_moderate: false,
        data: {},
      },
    }
  },
  created() {
    this.getUserData()
    if (this.$route.params.userId !== undefined) {
      this.currentLanding.user_id = this.$route.params.userId
    }
  },
  methods: {
    handleSwitchToEdit() {
      this.type = 'edit'
    },
    setBreabcrumbs() {
      if (this.$route.params.userId !== undefined) {
        this.breadcrumbItems = [
          {
            text: 'users',
            to: '/users',
          },
          {
            text: this.account.name,
            to: `/users/${this.$route.params.userId}`,
          },
          {
            text: 'landings.list',
            to: `/users/${this.$route.params.userId}/landings`,
          },
          {
            text: 'form.create',
            active: true,
          },
        ]
      } else {
        this.breadcrumbItems = [
          {
            text: 'landings.list',
            active: true,
          },
        ]
      }
    },
    async getUserData() {
      const responseData = await useJwt.getUser(this.$route.params.userId)
      this.account = responseData.data.account || []
      this.setBreabcrumbs()
    },
  },
}

</script>
